import { Loader } from '@googlemaps/js-api-loader';

let target = document.querySelector('.location');
let latitude = parseFloat(target.getAttribute('data-latitude'));
let longitude = parseFloat(target.getAttribute('data-longitude'));

let loader = new Loader({
  apiKey: window.contact_us_script_data.google_maps_api_key,
  version: 'weekly'
});

loader.load().then(() => {
  let coordinates = new google.maps.LatLng(latitude, longitude);

  let map = new google.maps.Map(document.getElementById('map'), {
    center: coordinates,
    zoom: 16,
    disableDefaultUI: false,
  });

  let marker = new google.maps.Marker({
    position: coordinates,
    map,
  });

  document.addEventListener('click', e => {
    let target = e.target;

    if (target.classList.contains('location')) {
      latitude = parseFloat(target.getAttribute('data-latitude'));
      longitude = parseFloat(target.getAttribute('data-longitude'));
      coordinates = new google.maps.LatLng(latitude, longitude);
      map.panTo(coordinates);
      marker.setPosition(coordinates);
      document.getElementById('map').scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  });
});

import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import ContactForm from './components/ContactForm';

Vue.config.devtools = true;
Vue.config.silent = false;

Vue.use(VueSweetalert2);

let vue_recaptcha_options = {
  siteKey: window.contact_us_script_data.google_recaptcha_site_key,
  loaderOptions: {
    autoHideBadge: false,
    explicitRenderParameters: {
      badge: 'bottomleft',
      // size: 'invisible',
    }
  }
};

Vue.use(VueReCaptcha, vue_recaptcha_options);

new Vue({
  el: '#contact-form',
  render: h => h(ContactForm),
});
